/************
 * Developed by : Shiva Software Solutions
 * Date : 31-10-2022
 * Descriptions : Route for dahboard page
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const mergedDoctorConfig = [
  //Redirect to dashboard page
  {
    auth: authRole.user,
    routes: [
      {
        path: '/doctor-deduplication',
        component: React.lazy(() => import('./MergeTabs')),
      },
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/merge-doctors',
        component: React.lazy(() => import('./mergeDoctorLists')),
      },
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/merge-prescription-doctors',
        component: React.lazy(() => import('./mergeDoctors')),
      },
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/verified-Doctors',
        component: React.lazy(() => import('./verifiedDoctors')),
      },
    ],
  },
];
